<template>
  <div v-if="drawerOpen" class="rqa_root" dir="rtl">
    <div class="rqa_overlay" @click="close"></div>
    <aside class="rqa_drawer" role="dialog" aria-modal="true" aria-labelledby="rqa_title">
      <header class="rqa_header">
        <h2 id="rqa_title" class="rqa_title">פניות למערכת</h2>
        <button
          v-if="view !== 'new'"
          type="button"
          class="button is-info is-small rqa_new"
          @click="startNew">פנייה חדשה</button>
        <button type="button" class="rqa_close" aria-label="סגירה" @click="close">×</button>
      </header>

      <div v-if="workerOffline" class="rqa_offline" role="status">
        המערכת לא זמינה כרגע. השאלה נשמרה ותיענה כשתחזור.
      </div>

      <p v-if="transferNotice" class="rqa_notice" role="status">{{ transferNotice }}</p>

      <recruiter-qa-thread v-if="view === 'thread' && selectedRootId" :key="'t' + selectedRootId" :root-id="selectedRootId" />
      <recruiter-qa-compose v-else-if="view === 'new'" />
      <recruiter-qa-ticket-list v-else />
    </aside>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import RecruiterQaTicketList from './RecruiterQaTicketList'
import RecruiterQaThread from './RecruiterQaThread'
import RecruiterQaCompose from './RecruiterQaCompose'
import { buildContextFromRoute, isContextFrozen } from '@/utils/recruiterQaContext'

// Shell: header, offline banner, and one of list / thread / new-request.
export default {
  name: 'RecruiterQaDrawer',
  components: { RecruiterQaTicketList, RecruiterQaThread, RecruiterQaCompose },
  data () {
    return { returnFocus: null }
  },
  computed: {
    modalAbove () {
      const modals = this.$store && this.$store.state.modals && this.$store.state.modals.modals
      return Array.isArray(modals) && modals.length > 0
    },
    ...mapState('recruiterQa', ['drawerOpen', 'view', 'selectedRootId', 'drafts', 'transferNotice']),
    ...mapGetters('recruiterQa', ['workerOffline'])
  },
  watch: {
    drawerOpen (open) {
      if (open) {
        this.returnFocus = document.activeElement
        this.followRoute()
      } else if (this.returnFocus && this.returnFocus.focus) {
        this.returnFocus.focus()
        this.returnFocus = null
      }
    },
    // New-request chips follow the route until typing starts; then frozen.
    $route () {
      if (this.drawerOpen) this.followRoute()
    }
  },
  mounted () {
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    ...mapActions('recruiterQa', ['closeDrawer', 'startNew']),
    followRoute () {
      if (!isContextFrozen(this.drafts.new)) {
        this.$store.commit('recruiterQa/SET_NEW_CONTEXT', buildContextFromRoute(this.$route))
      }
    },
    close () { this.closeDrawer() },
    onKeydown (event) {
      if (!this.drawerOpen || (event.key !== 'Escape' && event.key !== 'Esc')) return
      // A v_admin modal opened from the drawer (entity link) sits above it and
      // handles Escape itself; the drawer must stay.
      if (this.modalAbove) return
      this.close()
    }
  }
}
</script>
<style scoped>
.rqa_root {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100001;
  direction: rtl;
}
.rqa_overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
}
.rqa_drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 440px;
  max-width: 100%;
  background-color: #fff;
  color: #333;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  text-align: right;
}
.rqa_header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.rqa_title {
  flex: 1;
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}
.rqa_new {
  margin-left: 8px;
}
.rqa_close {
  background: none;
  border: none;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  color: #555;
  padding: 0 4px;
  min-width: 32px;
  min-height: 32px;
}
.rqa_offline {
  background-color: #fffaeb;
  color: #7a5b00;
  border-bottom: 1px solid #f1e2b0;
  padding: 8px 16px;
  font-size: 13px;
}
.rqa_notice {
  margin: 0;
  background-color: #f0f6ff;
  color: #1d3f72;
  border-bottom: 1px solid #cddcf3;
  padding: 8px 16px;
  font-size: 13px;
}
/* Mobile: full-screen panel; the composer stays visible (flex column, sticky). */
@media (max-width: 767px) {
  .rqa_overlay { display: none; }
  .rqa_drawer {
    width: 100%;
    height: 100%;
    height: 100dvh;
    box-shadow: none;
  }
  .rqa_new { min-height: 44px; }
  .rqa_close { min-width: 44px; min-height: 44px; }
}
</style>
